import React, { useState } from "react";
import Info from "./Info.svg";
import Text from "./text";

export default function PartnerInfoTooltip({ mediaQuery }) {
  const [show, setShow] = useState(false);
  return (
    <>
      <Info
        style={{ position: "absolute", marginTop: ".1rem", marginLeft: ".2rem", cursor: "pointer" }}
        onMouseOver={() => setShow(!show)}
        onMouseOut={() => setShow(!show)}
        onClick={() => {
          if (mediaQuery.isTabletOrMobile) {
            setShow(!show);
          }
        }}
      />
      <div
        style={{
          backgroundColor: "#D4D4D4",
          borderRadius: 6,
          height: "auto",
          padding: "1rem",
          position: "absolute",
          right: mediaQuery.isTabletOrMobile ? 0 : 95,
          top: mediaQuery.isTabletOrMobile ? 40 : -200,
          visibility: show ? "visible" : "hidden",
          width: mediaQuery.isTabletOrMobile ? "100%" : 450,
          zIndex: 100000
        }}
      >
        <Text>
          When both spouses or domestic partners are members of The Battery, the second member is
          eligible for a lower annual fee of $1,600. Both members must reside at the same address to
          qualify, the original member must pay the standard member rate. If the member paying the
          higher rate leaves the club for any reason, the member with the discounted rate will be
          required to upgrade at their next renewal to continue with their membership.
        </Text>
      </div>
      <div
        style={{
          backgroundColor: "#D4D4D4",
          width: 20,
          height: 20,
          transform: "rotate(45deg)",
          position: "absolute",
          top: mediaQuery.isTabletOrMobile ? 38 : -32,
          left: mediaQuery.isTabletOrMobile ? 79 : 312,
          visibility: show ? "visible" : "hidden"
        }}
      ></div>
    </>
  );
}
